import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from "./DeviceBehfa_Interface";

export interface PM_Service_Interface {
  id: number,

  base_date:String,
  next_date: String,

  program_id: number,
  type: number,
  title: String,

  username:String,

  deviceBehfa: DeviceBehfa_Interface,
}

export function Empty_PM_Service_Interface():PM_Service_Interface{
  return{
    id: 0,

    base_date:'',
    next_date: '',

    program_id: 0,
    type: 0,

    title:'',
    username:'',

    deviceBehfa: Empty_DeviceBehfa_Interface(),
  }
}

